if (!customElements.get('cat-wall-set-catalog')) {
  class CatWallSetCatalog extends HTMLElement {
    connectedCallback() {
      this.filters = Array.from(this.querySelectorAll('[data-catalog-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-catalog-card]'));
      this.countElement = this.querySelector('[data-catalog-count]');
      this.countTemplate = this.dataset.countTemplate || '[count] cat wall sets';
      this.totalCount = this.cards.length;

      if (this.filters.length === 0) {
        return;
      }

      this.filterClickHandler = this.handleFilterClick.bind(this);
      this.quantityClickHandler = this.handleQuantityClick.bind(this);
      this.quantityChangeHandler = this.handleQuantityChange.bind(this);

      this.filters.forEach((filter) => {
        filter.addEventListener('click', this.filterClickHandler);
      });
      this.addEventListener('click', this.quantityClickHandler);
      this.addEventListener('change', this.quantityChangeHandler);

      const initialFilterKey = this.getActiveFilterKey();
      this.applyFilter(initialFilterKey);
    }

    disconnectedCallback() {
      if (this.filters && this.filterClickHandler) {
        this.filters.forEach((filter) => {
          filter.removeEventListener('click', this.filterClickHandler);
        });
      }

      if (this.quantityClickHandler) {
        this.removeEventListener('click', this.quantityClickHandler);
      }

      if (this.quantityChangeHandler) {
        this.removeEventListener('change', this.quantityChangeHandler);
      }
    }

    handleFilterClick(evt) {
      const filter = evt.currentTarget;

      if (filter.getAttribute('aria-disabled') === 'true' || filter.classList.contains('is-disabled')) {
        evt.preventDefault();
        return;
      }

      evt.preventDefault();
      this.applyFilter(filter.dataset.catalogFilter || 'all');
      this.scrollFilterIntoView(filter);
    }

    handleQuantityClick(evt) {
      const button = evt.target.closest('[data-catalog-quantity-step]');
      if (!button || !this.contains(button)) return;

      const input = button.closest('[data-catalog-quantity]')?.querySelector('[data-catalog-quantity-input]');
      if (!input || input.disabled) return;

      const step = Number(button.dataset.catalogQuantityStep || 0);
      this.setQuantity(input, Number(input.value || 1) + step);
    }

    handleQuantityChange(evt) {
      if (!evt.target.matches('[data-catalog-quantity-input]')) return;
      this.setQuantity(evt.target, evt.target.value);
    }

    applyFilter(filterKey, updateCount = true) {
      const normalizedFilter = filterKey === 'all' ? 'all' : this.normalizeFilter(filterKey);
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        const isActive = (filter.dataset.catalogFilter || 'all') === normalizedFilter;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', String(isActive));
      });

      this.cards.forEach((card) => {
        const categories = (card.dataset.catalogCategories || '').split(/\s+/).filter(Boolean);
        const shouldShow = normalizedFilter === 'all' || categories.includes(normalizedFilter);

        card.hidden = !shouldShow;
        if (shouldShow) visibleCount += 1;
      });

      this.classList.toggle('is-empty', visibleCount === 0);

      if (this.countElement && updateCount) {
        const count = normalizedFilter === 'all' ? this.totalCount : visibleCount;
        this.countElement.textContent = this.countTemplate.replace('[count]', count);
      }
    }

    getActiveFilterKey() {
      const activeFilter = this.filters.find((filter) => filter.classList.contains('is-active'))
        || this.filters.find((filter) => filter.getAttribute('aria-pressed') === 'true')
        || this.filters[0];

      return activeFilter ? activeFilter.dataset.catalogFilter || 'all' : 'all';
    }

    normalizeFilter(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    setQuantity(input, value) {
      const min = Number(input.getAttribute('min') || 1);
      const max = Number(input.getAttribute('max') || 9);
      const parsedValue = parseInt(value, 10);
      const quantity = Number.isFinite(parsedValue) ? Math.min(Math.max(parsedValue, min), max) : min;

      input.value = quantity;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    scrollFilterIntoView(filter) {
      const scroller = filter.closest('.cat-wall-set-catalog__filters');

      if (!scroller || scroller.scrollWidth <= scroller.clientWidth) {
        return;
      }

      filter.scrollIntoView({
        block: 'nearest',
        inline: 'center',
        behavior: 'smooth'
      });
    }
  }

  customElements.define('cat-wall-set-catalog', CatWallSetCatalog);
}
